// Router-dom
import { Link } from 'react-router-dom';

// Bulma Components
import { Columns, Container, Hero, Image, Box, Button, Media, Heading} from 'react-bulma-components';

// MDI Icons
import Icon from '@mdi/react';
import { mdiMapMarkerMinusOutline, mdiShuffleVariant } from '@mdi/js';

// Components
import TimezoneClock from './TimezoneClock';
import WeatherCard from './WeatherCard';


// Header Component for Home page
const Header = (props) => {
    return (
        <Hero color="link" gradient>
        <Hero.Body >

          <Container>
            {/* Randomize button */}
            <Columns>
              <Columns.Column display="flex" size={9}>
              <span className="py-1 has-text-warning"><Icon size={1.5} path={mdiMapMarkerMinusOutline}/></span>
                <Heading className="is-align-items-centers" textWeight="bold">Random Country</Heading>
                  {/* pass in props.randomClick
                      - a function in Home page
                  */}
                  <Button mx={4} px={6} color="warning" textWeight="semibold" rounded onClick={() => props.randomClick()}>
                    <Icon size={1} path={mdiShuffleVariant}/>
                    Randomize
                    </Button>
              </Columns.Column>
            </Columns>
          </Container>

          {/* Common details of the country */}
          <Box renderAs={Container}>
            <Columns justifyContent="end">
              <Columns.Column size={7}>
                    {/* Country name and coat of arms */}
                    <Media renderAs={Link} to={`/country/${props.random.name.common}`}>
                        {(props.random.coatOfArms) ? 
                            <Media.Item align="left" renderAs="figure">
                                <Image src={props.random.coatOfArms.png} size={48}/>
                            </Media.Item> :
                            null
                        }
                        <Media.Item key="test">
                            <Heading textColor="black" size={1}>
                                {props.random.name.common}
                            </Heading>
                        </Media.Item>
                    </Media>

                    <hr/>

                    {/* Subregion, capital city and population */}
                    <Columns.Column ml={5}>
                      <Heading textColor="dark" ml={6} className="is-size-5">Region: {props.random.subregion}
                      </Heading>
                      <Heading textColor="dark" ml={6} className="is-size-5">Capital: {props.random.capital}</Heading>
                      <Heading textColor="dark" ml={6} className="is-size-5">Population: {props.random.population.toLocaleString('en-US')} citizens</Heading>
                    </Columns.Column>

                    <hr/>
                    
                    {/* Weather and Timezone Components */}
                    <Columns.Column display='flex'>
                      <WeatherCard  latlon={props.random.latlng}/>
                      <TimezoneClock latlon={props.random.latlng}/>
                    </Columns.Column>

              </Columns.Column>

              <Columns.Column>
              {/* Flag */}
                <Image
                  renderAs={Link} size="16by9" to={`/country/${props.random.name.common}`}
                  src={props.random.flags.png}
                />
              </Columns.Column>
            </Columns>
          </Box>
        </Hero.Body>
      </Hero>
    );
};

export default Header;